webpackJsonp([263791100135453],{

/***/ 255:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(30);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(32);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _board = __webpack_require__(35);
	
	var _board2 = _interopRequireDefault(_board);
	
	var _aboutModule = __webpack_require__(341);
	
	var _aboutModule2 = _interopRequireDefault(_aboutModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
			var data = _ref.data;
			return _react2.default.createElement(
					"div",
					null,
					_react2.default.createElement(_reactHelmet2.default, {
							title: "About | " + data.site.siteMetadata.title
					}),
					_react2.default.createElement(
							"section",
							null,
							_react2.default.createElement(
									"h2",
									{ className: _aboutModule2.default.sectionTitle },
									data.site.siteMetadata.title,
									" #\u3068\u306F"
							),
							_react2.default.createElement(
									_board2.default,
									null,
									_react2.default.createElement(
											"p",
											null,
											"\u672D\u5E4C\u306E\u30AB\u30B8\u30E5\u30A2\u30EB\u306A\u30D0\u30FC\u3092\u4F1A\u5834\u3068\u3057\u3066\u98F2\u98DF\u3092\u697D\u3057\u307F\u3064\u3064\u3001\u6BCE\u56DE\u3072\u3068\u3064\u306E\u30C6\u30FC\u30DE\u3092\u6C7A\u3081\u3001\u7814\u7A76\u767A\u8868(\u30C8\u30FC\u30AF\u30A4\u30D9\u30F3\u30C8)\u3084\u3001\u52C9\u5F37\u4F1A\u306A\u3069\u3092\u884C\u3046\u4F1A\u3067\u3059\u3002",
											_react2.default.createElement("br", null),
											"\u6570\u5B66\u3001\u7269\u7406\u5B66\u304B\u3089\u54F2\u5B66\u3001\u82B8\u8853\u307E\u3067\u3001\u666E\u6BB5\u304B\u304B\u308F\u308B\u3053\u3068\u306E\u306A\u3044\u5206\u91CE\u306E\u77E5\u8B58\u306B\u89E6\u308C\u3001\u8077\u696D\u3084\u5E74\u9F62\u306B\u95A2\u4FC2\u306A\u304F\u3001\u30D5\u30EA\u30FC\u30C0\u30E0\u306B\u5B66\u3073\u3001\u8003\u3048\u308B\u3053\u3068\u3092\u697D\u3057\u3081\u308C\u3070\u3068\u601D\u3044\u307E\u3059\u3002"
									)
							)
					),
					_react2.default.createElement(
							"section",
							null,
							_react2.default.createElement(
									"h2",
									{ className: _aboutModule2.default.sectionTitle },
									"\u958B\u50AC\u306E\u52D5\u6A5F"
							),
							_react2.default.createElement(
									_board2.default,
									null,
									_react2.default.createElement(
											"ul",
											null,
											_react2.default.createElement(
													"li",
													null,
													"\u6771\u4EAC\u3067\u3084\u3063\u3066\u308B",
													_react2.default.createElement(
															"a",
															{ href: "http://kiwi-lab.com/event.html", target: "_blank" },
															"\u5927\u4EBA\u306E\u79D1\u5B66\u30D0\u30FC"
													),
													"\u306B\u884C\u304D\u305F\u3044\u3051\u3069\u306A\u304B\u306A\u304B\u30BF\u30A4\u30DF\u30F3\u30B0\u304C\u5408\u308F\u306A\u3044\u3002"
											),
											_react2.default.createElement(
													"li",
													null,
													"\u672D\u5E4C\u3067\u9762\u767D\u3044\u7814\u7A76\u3092\u3057\u3066\u308B\u4EBA\u3092\u77E5\u308A\u305F\u3044\u3002"
											),
											_react2.default.createElement(
													"li",
													null,
													"\u5927\u4EBA\u306B\u306A\u3063\u3066\u3001\u4ED5\u4E8B\u4EE5\u5916\u3067\u771F\u9762\u76EE\u306B\u8B70\u8AD6\u3057\u305F\u308A\u8B1B\u7FA9\u3092\u8074\u3044\u305F\u308A\u3059\u308B\u6A5F\u4F1A\u304C\u306A\u3044\u3002"
											),
											_react2.default.createElement(
													"li",
													null,
													"\u5B66\u751F\u6642\u4EE3\u3001\u767D\u718A\u306E\u751F\u614B\u30D3\u30C7\u30AA\u3092\u898B\u306A\u304C\u3089\u98F2\u3093\u3067\u305F\u30CE\u30EA\u3092\u307E\u305F\u3084\u308A\u305F\u3044\u3002"
											)
									)
							)
					),
					_react2.default.createElement(
							"section",
							null,
							_react2.default.createElement(
									"h2",
									{ className: _aboutModule2.default.sectionTitle },
									"\u958B\u50AC\u65E5\u6642\u306A\u3069"
							),
							_react2.default.createElement(
									_board2.default,
									null,
									_react2.default.createElement(
											"p",
											null,
											"\u307E\u3060\u767A\u8DB3\u76F4\u5F8C\u306A\u306E\u3067\u308F\u304B\u308A\u307E\u305B\u3093\u304C\u3001\u3072\u3068\u307E\u305A\u9694\u6708\u4EE5\u4E0A\u3067\u958B\u50AC\u3067\u304D\u308B\u3088\u3046\u306B\u3057\u3066\u3044\u304D\u305F\u3044\u3068\u306F\u601D\u3063\u3066\u3044\u307E\u3059\u3002 \u4F1A\u5834\u3082\u6700\u521D\u306E\u3046\u3061\u306F\u4F55\u56DE\u304B\u5909\u66F4\u3059\u308B\u304B\u3082\u3057\u308C\u307E\u305B\u3093\u3002",
											_react2.default.createElement("br", null),
											"\u4E0D\u660E\u70B9\u306A\u3069\u3042\u308C\u3070",
											_react2.default.createElement(
													_gatsbyLink2.default,
													{ to: "/contact" },
													"Contact"
											),
											"\u306E\u9023\u7D61\u5148\u3078\u3069\u3046\u305E\u3002"
									)
							)
					)
			);
	};
	
	var query = exports.query = "** extracted graphql fragment **";

/***/ }),

/***/ 341:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"sectionTitle":"src-styles----about-module---sectionTitle---3I4Nu"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-0d12a691297da11316fe.js